class AuthService {
  get user() {
    return localStorage.getItem("user-data");
  }

  get isAuthenticated() {
    return localStorage.getItem("user-data") !== null;
  }

  get token() {
    if (!this.isAuthenticated) return null;

    return JSON.parse(localStorage.getItem("user-data")).access_token;
  }

  get id() {
    if (!this.isAuthenticated) return null;

    return JSON.parse(localStorage.getItem("user-data")).id;
  }

  get phone() {
    if (!this.isAuthenticated) return null;

    return JSON.parse(localStorage.getItem("user-data")).phone;
  }

  get privileged() {
    if (!this.isAuthenticated) return null;

    return JSON.parse(localStorage.getItem("user-data")).privileged;
  }

  login({ access_token, privileged, phone }) {
    localStorage.setItem(
      "user-data",
      JSON.stringify({
        access_token,
        privileged,
        phone,
      })
    );
  }

  updateUserData({ phone, id }) {
    if (!this.isAuthenticated) return;

    const data = JSON.parse(localStorage.getItem("user-data"));
    data.phone = phone;
    data.id = id;

    localStorage.setItem("user-data", JSON.stringify(data));
  }

  logout() {
    localStorage.clear();
    sessionStorage.clear();
  }
}

const authService = new AuthService();
export default authService;
